import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { HomePage } from "@/pages/HomePage";
import { SharedReadingPage } from "@/pages/SharedReadingPage";
import { PairSharedReadingPage } from "@/pages/PairSharedReadingPage";
import { LegalPage } from "@/pages/LegalPage";
import { AboutPage } from "@/pages/AboutPage";
import { HowItWorksPage } from "@/pages/HowItWorksPage";
import { FaqPage } from "@/pages/FaqPage";
import { TermsPage } from "@/pages/TermsPage";
import { ContactPage } from "@/pages/ContactPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { ZodiacHubPage } from "@/pages/ZodiacHubPage";
import { ZodiacSignPage } from "@/pages/ZodiacSignPage";
import { LearnHubPage } from "@/pages/LearnHubPage";
import { RisingSunMoonPage } from "@/pages/learn/RisingSunMoonPage";
import { HowToReadBirthChartPage } from "@/pages/learn/HowToReadBirthChartPage";
import { VedicVsWesternPage } from "@/pages/learn/VedicVsWesternPage";

function App() {
  return (
    <BrowserRouter>
      <div className="App cosmic-bg min-h-screen">
        <div className="starfield" />
        <div className="grain" />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/r/pair/:token" element={<PairSharedReadingPage />} />
          <Route path="/r/:token" element={<SharedReadingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/zodiac" element={<ZodiacHubPage />} />
          <Route path="/zodiac/:sign" element={<ZodiacSignPage />} />
          <Route path="/learn" element={<LearnHubPage />} />
          <Route path="/learn/rising-sign-vs-sun-sign-vs-moon-sign" element={<RisingSunMoonPage />} />
          <Route path="/learn/how-to-read-a-birth-chart" element={<HowToReadBirthChartPage />} />
          <Route path="/learn/vedic-vs-western-astrology" element={<VedicVsWesternPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Toaster theme="dark" position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
